// src/pages/acceptInviteError.js
//
// What the accept pages say when an invite can't be accepted. Shared by
// AcceptInvitePage and AcceptOrgInvitePage.
//
// Keyed on the server's `code`, never on the status alone. Every 403 used to
// read "sent to a different email address", and a 403 now also means "verify
// your email first" (email_unverified, REM-449). Telling a person who used the
// right address that they used the wrong one sends them looking for an account
// that does not exist. A status with no code we know gets the generic line.

const MESSAGES = {
  email_unverified:
    "Verify your email address to accept this invitation. Check your inbox for " +
    "the verification email, then open this link again.",
  invite_email_mismatch:
    "This invite was sent to a different email address. " +
    "Sign in with the invited account to accept.",
  invite_not_found: "This invite no longer exists.",
  invite_revoked: "This invite has been revoked.",
  terms_not_published:
    "This invitation can't be accepted yet because platform terms haven't been " +
    "published. Please try again later or contact the person who invited you.",
}

const EXPIRED = {
  project: "This invite has expired. Ask the project admin to send a new one.",
  org: "This invite has expired. Ask your admin to send a new one.",
}

export function acceptInviteErrorMessage(status, body, kind) {
  const code = body?.code
  if (code === 'invite_expired') return EXPIRED[kind] ?? EXPIRED.org
  if (code && MESSAGES[code]) return MESSAGES[code]
  return `Could not accept invite (error ${status}).`
}
